import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/yk/Dev/BaseballDataViewer/nextjs/components/client/LandingClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/yk/Dev/BaseballDataViewer/nextjs/node_modules/next/dist/client/app-dir/link.js");
